export enum UserRole {
    SUPER_ADMIN = "superadmin",
    ADMIN = "admin",
    USER = "user",
}